import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { EventsService } from 'src/app/providers/events/events.service';
import { IonAccordionGroup, LoadingController, NavController } from '@ionic/angular';
import * as moment from 'moment';

@Component({
  selector: 'app-correspondence',
  templateUrl: './correspondence.page.html',
  styleUrls: ['./correspondence.page.scss'],
})
export class CorrespondencePage implements OnInit {
  @ViewChild('accordionGroup', { static: true }) accordionGroup: IonAccordionGroup;

  user: any;
  fullname: string;
  email:string;
  username:string;
  files:any;
  oldfiles:any;
  newfiles:any;
  year:number;
  newfilescount:number = 0;
  oldfilescount:number = 0;

  constructor(
    public storageService: StorageService,
    public apiService: ApiService,
    public events: EventsService,
    public navCtrl: NavController,
    private loadingCtrl: LoadingController,
  ) { }

  ionViewDidEnter() {

    document.title = "Medbill Client Portal - Correspondence";
    this.year = new Date().getFullYear();    
  }

  async ngOnInit() {
    await this.getUser();
    await this.getCorrespondence();
    
  }

  reorderFiles() {
    const newFilesSet = new Set();
    const oldFilesSet = new Set();
    for (let i = 0; i < this.files.length; i++) {
      const corDate = moment(this.files[i].attributes.description);
      const today = moment();
      if (corDate > today.add(-7, 'days')) {
        newFilesSet.add(this.files[i]);
      } else {
        oldFilesSet.add(this.files[i]);
      }
    }
  
    this.oldfiles = oldFilesSet;
    this.newfiles = newFilesSet;
    
    this.oldfilescount = oldFilesSet.size;
    this.newfilescount = newFilesSet.size;

    if (this.newfilescount == 0)
    {

      this.accordionGroup.value = 'second';
    }
  
  }
  async getUser() {
    await this.storageService
      .getObject('userInfo')
      .then((result) => {
        if (result != null) {
          this.user = result;
          this.events.publish('user:active', this.user);
        }
      })
      .catch((e) => {
        // Handle errors here
      });

    await this.storageService
    .getObject('mbeUser')
    .then((result) => {
      if (result != null) {
        this.user = result;
        this.fullname = this.user.first_name + ' ' + this.user.last_name;
        this.email = this.user.email;
        this.username = this.user.username;
      }
    })
    .catch((e) => {
      // Handle errors here
    });
  }

  async getCorrespondence() {
    const loading = await this.loadingCtrl.create({
      message: 'Loading Files.  Please Wait...',
      mode: 'ios',
    });

      const params = {
      };
      loading.present();
      this.apiService.post('correspondence-list', params).subscribe(
        async (res) => {
          loading.dismiss();
          if (res.error === false) {
            this.files = res.data;
            //console.log(this.files);
            //descending order by description field (which we will use as the date)
            if (this.files)
            {
              this.files.sort((x,y) => (x.attributes.description < y.attributes.description) ? 1 : ((y.attributes.description < x.attributes.description) ? -1 : 0));
              this.reorderFiles();
            }
          }
        },
        (err) => {
          loading.dismiss();          
        }
      );
    }
   
    download(url){
      window.open(url, "_blank");
    }

    logout() {
      this.apiService.weblogout();
      this.navCtrl.navigateRoot('/web', { animated: true });
    }
    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event): void {
      // Call the logout function when the user closes the window
      this.logout();
    }
}
